<template>
  <div class="service-list">
    <h3>Services</h3>
    <div class="list-group">
      <service-item
        v-for="(service, index) in services"
        :key="index"
        :service-name="service.name"
        :service-url="service.url"
      />
    </div>
  </div>
</template>

<script>
import ServiceItem from "./ServiceItem.vue"

export default {
  name: "ServiceList",
  components: {
    ServiceItem
  },
  data() {
    return {
      services: [
        { name: "Shop", url: "https://www.schindelhauerbikes.com/" },
        { name: "Versicherung", url: "https://www.schindelhauerbikes.com/" }
      ]
    };
  }
};
</script>